"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react2 = require("../..");

require("@zebra-fed/icons/Navigation/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    height: ", ";\n    width: fit-content;\n    color: ", ";\n    background-color: ", ";\n    font-family: ", ";\t\n    font-size: ", ";\n    font-weight: 400;\t\n    letter-spacing: -0.2px;\t\n    opacity: ", ";\n    cursor: default\n    &:hover {\n        opacity: ", ";\n    }\n    display: ", ";\n    align-items:center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ChipWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.spacingObj.height * 2 + 'px';
}, function (props) {
  return props.spacingObj.height + 'px';
}, function (props) {
  return props.colorObj.color;
}, function (props) {
  return props.disabled ? props.colorObj.disabled : props.colorObj.backgroundColor;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.disabled ? .5 : 1.0;
}, function (props) {
  return props.disabled ? .5 : .8;
}, function (props) {
  return props.canceled ? 'none' : 'flex';
});
/**
 * Chips are compact elements that represent an input, attribute, or action. 
 * @example import { Chip } from '@desktop/react'; 
 */


var Chip = function Chip(props) {
  var inherit = 'chip';
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit];
  var colors = context.getColors()[inherit][props.type];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      canceled = _useState2[0],
      setCanceled = _useState2[1];

  function close() {
    props.onClose();
    setCanceled(true);
  }

  return /*#__PURE__*/_react["default"].createElement(ChipWrapper, {
    style: props.style,
    spacingObj: spacing,
    colorObj: colors,
    disabled: props.disabled,
    canceled: canceled,
    fontFamilyObj: context.getFont()
  }, !props.hideIcon && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: spacing.margin,
      cursor: props.disabled ? 'default' : 'pointer'
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    name: 'close',
    category: 'navigation',
    hover: !props.disabled,
    color: "white",
    size: 20,
    onClick: props.disabled ? null : close
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginRight: spacing.margin * 4,
      marginLeft: props.hideIcon ? spacing.margin * 4 : 0
    }
  }, props.children));
};

exports.Chip = Chip;
Chip.propTypes = {
  /**The content displayed inside the chip. */
  children: _propTypes["default"].node,

  /**Inherits styling based on the type of chip to display. Possible types are primary and secondary. */
  type: _propTypes["default"].string,

  /**Toggle to enable and disable the chip control. */
  disabled: _propTypes["default"].bool,

  /**Extends the base styling of the chip element. */
  style: _propTypes["default"].object,

  /**The callback function fired when the chip is closed. */
  onClose: _propTypes["default"].func,

  /**Hides the close icon. */
  hideIcon: _propTypes["default"].bool
};
Chip.defaultProps = {
  type: 'primary',
  disabled: false,
  style: {},
  onClose: function onClose() {
    return false;
  },
  hideIcon: false
};